<template>
  <!-- Tasks dots menu — contextual bottom sheet (matches the other app menus) -->
  <v-bottom-sheet
    v-model="showTasksMenu"
    inset
    class="rounded"
    width="90%"
    v-if="$route.name !== 'NoAccess' && $route.name !== 'AccessDenied'"
  >
    <v-list density="comfortable">
      <v-toolbar density="compact" color="transparent">
        <v-toolbar-title>Tasks</v-toolbar-title>
        <template v-slot:append>
          <v-btn icon size="large" @click="showTasksMenu = false">
            <v-icon>mdi-close</v-icon>
            <v-tooltip activator="parent" location="bottom">Close</v-tooltip>
          </v-btn>
        </template>
      </v-toolbar>

      <v-divider></v-divider>

      <!-- Assign a task (managers / appadmin only) -->
      <v-list-item v-if="canAssign" @click="onAssign">
        <template v-slot:prepend>
          <v-icon icon="mdi-plus" color="deep-purple-lighten-1"></v-icon>
        </template>
        <template v-slot:title>Assign task</template>
        <template v-slot:subtitle>Hand a task down your line of command</template>
      </v-list-item>

      <!-- Chain of command visualization (appadmin only) -->
      <v-list-item v-if="isAppAdmin" @click="onOrg">
        <template v-slot:prepend>
          <v-icon icon="mdi-sitemap" color="primary"></v-icon>
        </template>
        <template v-slot:title>Chain of command</template>
        <template v-slot:subtitle>View the reporting tree</template>
      </v-list-item>

      <v-divider class="my-1"></v-divider>

      <!-- Timeline view of the current (filtered/sorted) tasks -->
      <v-list-item @click="onTimeline">
        <template v-slot:prepend>
          <v-icon icon="mdi-chart-timeline"></v-icon>
        </template>
        <template v-slot:title>Timeline</template>
        <template v-slot:subtitle>Filtered tasks grouped by due date</template>
      </v-list-item>

      <!-- Sort the board -->
      <v-list-item @click="onSort">
        <template v-slot:prepend>
          <v-icon icon="mdi-tune"></v-icon>
        </template>
        <template v-slot:title>Sort</template>
        <template v-slot:subtitle>Order by due date, entered date or tags</template>
      </v-list-item>

      <!-- Toggle board layout (cards <-> list) -->
      <v-list-item @click="onToggleView">
        <template v-slot:prepend>
          <v-icon :icon="viewMode === 'cards' ? 'mdi-view-list' : 'mdi-view-grid'"></v-icon>
        </template>
        <template v-slot:title>{{ viewMode === "cards" ? "List view" : "Card view" }}</template>
        <template v-slot:subtitle>Switch the task layout</template>
      </v-list-item>
    </v-list>
  </v-bottom-sheet>
</template>

<script setup>
import { useApp } from "@/composables/useApp.js";
import { useTasks } from "@/composables/useTasks.js";

const { showTasksMenu } = useApp();
const {
  canAssign,
  isAppAdmin,
  viewMode,
  toggleViewMode,
  openAssignDialog,
  orgDialogOpen,
  openSortDialog,
  openTimelineDialog,
} = useTasks();

/** Open the assign dialog and close the sheet. */
function onAssign() {
  showTasksMenu.value = false;
  openAssignDialog(null);
}

/** Open the sort dialog and close the sheet. */
function onSort() {
  showTasksMenu.value = false;
  openSortDialog();
}

/** Open the timeline dialog and close the sheet. */
function onTimeline() {
  showTasksMenu.value = false;
  openTimelineDialog();
}

/** Toggle the board layout and close the sheet. */
function onToggleView() {
  showTasksMenu.value = false;
  toggleViewMode();
}

/** Open the chain-of-command dialog and close the sheet. */
function onOrg() {
  showTasksMenu.value = false;
  orgDialogOpen.value = true;
}
</script>
